import React from "react";
import { useDispatch } from "react-redux";

import Login_side from "../assets/login-page-background-solar-tech.webp";
import loginLogo from "../assets/zeos-ai-blue-logo.png";
import { ZeosSignin } from "../components/Shared/ZeosSignin";

// import { login } from '../redux-store/_deprecated/UserSlice';

export const Login = () => {
  const dispatch = useDispatch();
  return (
    <div className="h-screen flex bg-white">
      <div className="min-w-[400px] pb-5">
        <ZeosSignin
          defaultUsername="demo@rewiregroup.net"
          defaultPassword="demo@1234"
          resetLinkSource="dashboard"
          logoSrc={loginLogo}
          buttonClassName="zeos-login-button"
          onSuccess={
            (user) => {}
            // (user) => {dispatch(login({ username: user.username, userId: user.zeosUserId }));}
          }
          onFailure={() => {}}
          buttonLabel="Login"
        />
      </div>

      <div
        className="flex-1"
        style={{
          backgroundImage: `url(${Login_side})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      ></div>
    </div>
  );
};
